import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-central-display',
  templateUrl: './central-display.component.html'
})
export class CentralDisplayComponent implements OnInit {
  public title: String;
  public version: String;
  public expertiseLabel: String;
  public areaOfExpertise: String;
  public logo: String;
  constructor() { }

  ngOnInit() {
    this.title = 'Freeground';
    this.version = 'v1.0.0';
    this.expertiseLabel = 'Deploying Services to Irvine';
    this.areaOfExpertise = 'Web Applications & User-interface Design';
    this.logo = '/assets/images/freeground.svg'
  }
}



// WEBPACK FOOTER //
// /Users/jessepinuelas/Development/jesse/freeground.io/src/app/central-display/central-display.component.ts